import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Courier } from '../../models/courier';
import { CourierService } from '../../services/courier.service';

export type PassOrderConfirmationData = {
  orderNumber: number,
  orderId: string,
  courier: Courier,
}

@Component({
  templateUrl: './pass-order-confirmation.component.html',
  styleUrls: ['./pass-order-confirmation.component.scss'],
})
export class PassOrderConfirmationComponent {
  @Input({ required: true }) data!: PassOrderConfirmationData;
  isPassingOrder = false;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private courierService: CourierService,
  ) {
  }

  async closeModal(): Promise<void> {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }

  cancel(): void {
    this.closeModal();
  }

  confirm(): void {
    if (this.isPassingOrder) return;

    this.isPassingOrder = true;
    this.courierService.passOrderToCourier(this.data.courier.id, this.data.orderId)
      .subscribe(() => {
        this.navController.back();
        this.closeModal();
      });
  }

}
